import React from 'react'
import './clientGoalItem.scss'
import { numberFormatter } from 'helpers'
import { CheckMarkIcon } from 'assets'

export type GroupedGoalItems = {
    productId: string
    productName: string
    price: number
    imageUrl: string
    nbOfGoalItems: number
    finished?: boolean
}

export const ClientGoalItem = ({
    goalItem,
    color,
    finished,
    finishedIndicatorVariant = 'finished'
}: {
    goalItem: GroupedGoalItems
    color: string
    finished?: boolean
    finishedIndicatorVariant?: 'finished' | 'delivered'
}) => {
    return (
        <div className="client-goal-item-container">
            <div
                className="client-goal-item-borders"
                style={{ borderColor: color }}
            >
                <p className="client-goal-item-name">{goalItem.productName}</p>
                <img
                    className="client-goal-item-img"
                    src={goalItem.imageUrl}
                    alt={goalItem.productName}
                    onError={(
                        event: React.SyntheticEvent<HTMLImageElement, Event>
                    ) =>
                        ((event.target as HTMLImageElement).style.display =
                            'none')
                    }
                />
            </div>
            <p className="client-goal-item-price" style={{ color }}>
                {numberFormatter(goalItem.price)}
            </p>
            <p
                className="client-goal-item-units"
                style={{ backgroundColor: color }}
            >
                {goalItem.nbOfGoalItems}
            </p>
            {finished && (
                <div
                    className={`client-goal-item-finished client-goal-item-finished--${finishedIndicatorVariant}`}
                    aria-label="finished-indicator"
                >
                    <CheckMarkIcon color={color} />
                </div>
            )}
        </div>
    )
}
